import usePrivateAxios from '@/common/api/usePrivateAxios'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { ProductNfceMappingData, ProductNfceMappingResponse } from '../types/productNfceMapping'

export const useProductNfceMapping: (id: string) => UseQueryResult<ProductNfceMappingData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<ProductNfceMappingResponse, unknown, ProductNfceMappingData>({
    queryKey: ['productNfceMapping', id],
    queryFn: () => privateAxios.get(`/product_nfce_mappings/${id}`),
    select: (data) => data?.data?.data,
  })
}
